import { CallOverrides } from "ethers";
      /* tslint:disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export type CommunityCallContractFunctions1 =
  | []
  | [CommunityCallContractFunctions]
  | [CommunityCallContractFunctions, CommunityCallContractEvents];
export type SWEvent = {
  event: CommunityCallContractEventType;
  args: any;
}[];

export interface CommunityCallContractFunctions {
  close: (
    comCallID: number,
    results: string,
    participants: string[],
    overrides?: CallOverrides
  ) => Promise<{wait: () => Promise<CommunityCallContractEvents>}>;
  create: (
    _role: number,
    _startTime: number,
    _endTime: number,
    _uri: string,
    overrides?: CallOverrides
  ) => Promise<number>;
  discordBot: (overrides?: CallOverrides) => Promise<string>;
  setDiscordAddress: (
    _discordBot: string,
    overrides?: CallOverrides
  ) => Promise<{wait: () => Promise<CommunityCallContractEvents>}>;
}
export interface CommunityCallContractEvents {
  events: SWEvent;
}

export enum CommunityCallContractEventType {
  CommunityCallClosed = "CommunityCallClosed",
  CommunityCallCreated = "CommunityCallCreated"
}
